import createClient from 'openapi-fetch';
import { toTabFileError } from './errors';
async function readProblemBody(response) {
    try {
        const text = await response.clone().text();
        if (!text)
            return undefined;
        return JSON.parse(text);
    }
    catch {
        return undefined;
    }
}
/**
 * Builds a typed client for TabFile. Every method resolves with the response
 * body and throws a {@link TabFileError} for any non 2xx answer, so callers and
 * React Query only deal with one error type.
 */
export function createTabFileClient(options) {
    const raw = createClient({
        baseUrl: options.baseUrl,
        fetch: options.fetch,
        headers: options.headers,
    });
    raw.use({
        async onRequest({ request }) {
            const auth = options.getAuth ? await options.getAuth() : undefined;
            if (auth && 'apiKey' in auth && auth.apiKey) {
                request.headers.set('X-Api-Key', auth.apiKey);
            }
            else if (auth && 'bearer' in auth && auth.bearer) {
                request.headers.set('Authorization', `Bearer ${auth.bearer}`);
            }
            return request;
        },
    });
    async function call(method, path, init) {
        const { idempotencyKey, ...rest } = (init ?? {});
        const headers = { ...(rest.headers ?? {}) };
        if (idempotencyKey)
            headers['Idempotency-Key'] = idempotencyKey;
        const fn = raw[method];
        const result = await fn(path, { ...rest, headers });
        const { response } = result;
        if (!response.ok) {
            const body = result.error !== undefined ? result.error : await readProblemBody(response);
            const error = toTabFileError(response.status, body, response.statusText);
            if (error.status === 401)
                options.onUnauthorized?.(error);
            throw error;
        }
        return result.data;
    }
    return {
        raw,
        GET: (path, init) => call('GET', path, init),
        POST: (path, init) => call('POST', path, init),
        PATCH: (path, init) => call('PATCH', path, init),
        PUT: (path, init) => call('PUT', path, init),
        DELETE: (path, init) => call('DELETE', path, init),
    };
}
//# sourceMappingURL=client.js.map